"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FilterableViewComponent = void 0;
var lodash_1 = require("lodash");
var FilterableViewComponent = (function () {
    function FilterableViewComponent(instanceId) {
        var _this = this;
        this._elementInstanceId = instanceId;
        document.addEventListener("onFilterChange", (function (event) {
            var filter = event.detail;
            if (_this._elementInstanceId !== filter.instanceId) {
                _this.onFilterChange(filter.data);
            }
        }));
        document.addEventListener('onRefreshDataRequest', (function (event) {
            _this.onRefreshDataRequest();
        }));
    }
    FilterableViewComponent.prototype.applyFilter = function (newFilter) {
        var unreferencedNewFilter = (0, lodash_1.cloneDeep)(newFilter);
        var filter = new VcFilter(this._elementInstanceId, unreferencedNewFilter);
        document.dispatchEvent(new CustomEvent("onFilterChange", { detail: filter }));
    };
    return FilterableViewComponent;
}());
exports.FilterableViewComponent = FilterableViewComponent;
var VcFilter = (function () {
    function VcFilter(instanceid, filter) {
        this.instanceId = instanceid;
        this.data = filter;
    }
    return VcFilter;
}());
